import ApproveQuotes from "../ApproveQuotes/ApproveQuotes";
import { calculateLineItemsTotal } from "../../../../util/Util";
import * as _ from "lodash";
import { APPROVE_PROPS, QUOTE } from "../Types";
import Big from "big.js";
import { Position } from "puzzle";

class AddEditPO extends ApproveQuotes<APPROVE_PROPS, {}> {
  static defaultProps = {
    userName: '',
    showFooter: false
  };

  constructor(props: APPROVE_PROPS) {
    super(props);
    this.state.hasAlreadyApproved = false;
    this.state.comments = [];
    this.state.showComments = false;
    this.dispatch('updateApproveQuoteGrandTotal', Position.end, { grandTotal: this.calculateQuoteGrandTotal() });
  }

  /**
   * overrides
   *
   * @param poNumber
   */
  applyPOToAllScopes = (poNumber: number) => {
    this.exitEdit();
    const { data, showApprovedQuotes } = this.state;
    data.quotes.map((currentQuote: any) => currentQuote.poNumber = poNumber);
    const gridConfig = this.createAppState({
      group: [{ field: "displayName" }]
    }, showApprovedQuotes, data);
    this.setState({
      gridConfig,
      data
    })
  };

  /**
   * overrides
   */
  getDataForPost = () => {
    const { data } = this.state;
    let quotes = _.reduce(data.quotes, this.getQuotesForPost, []);
    return quotes;
  };

  /**
   * Calculate quote total value
   */
  calculateQuoteGrandTotal = () => {
    const { quoteConfiguration, quotes } = this.props.data;
    let total = Big(0);
    let quotesLength = quotes.length;
    let currentQuote;
    let currentQuoteTotal;
    while (quotesLength) {
      quotesLength--;
      currentQuote = quotes[quotesLength];

      if (currentQuote.status === 'APPROVED' || currentQuote.approved) {
        currentQuoteTotal = calculateLineItemsTotal(currentQuote.lineItems, true, true, false);
        total = total.plus(currentQuoteTotal);
      }

    }
    let currency = currentQuote?.currency;
    let totalFormatted: number | string = total.toFixed(quoteConfiguration.numberPrecision);
    if (currency) {
      totalFormatted = this.getCurrencyFormattedTotal(totalFormatted, currency);
    }

    return totalFormatted;
  };

  /**
   * Get formatted total with currency
   */
  getCurrencyFormattedTotal = (total: string, currency: string) => {
    let formatted = this.translate('currencyTotalFormat', { currency, total });
    return formatted;
  };

  /**
   * overrides
   *
   * @param array
   * @param quote
   */
  getQuotesForPost = (array: any[], quote: QUOTE) => {
    array.push({
      quoteId: quote.quoteId,
      poNumber: quote.poNumber
    });
    return array;
  };

  /**
   * overrides
   */
  isApproveAllowed = () => {
    const { poMandatory } = this.props.data.quoteConfiguration;
    let isAllowed = true;
    if (poMandatory) {
      isAllowed = !(_.filter(this.state.data.quotes, (quote: QUOTE) => {
        return (quote.status === 'APPROVED' || quote.approved) && !quote.poNumber;
      }).length);
    }
    return isAllowed;
  };

  /**
   * overrides
   *
   * @param withApproved
   * @param quotesData
   */
  updateData = (withApproved: boolean, quotesData: any) => {
    let parsedScopes = [];
    let quotes = quotesData.quotes;
    let quotesLength = quotes.length;
    let i = 0;
    let currentQuotes;
    const { quoteConfiguration } = this.props.data;
    while (i < quotesLength) {
      currentQuotes = quotes[i];
      if (currentQuotes.status === 'APPROVED') {
        parsedScopes.push({
          ...currentQuotes.quoteScope,
          amount: calculateLineItemsTotal(currentQuotes.lineItems, true, true, false).round(quoteConfiguration.numberPrecision).toNumber(),
          displayName: currentQuotes.quoteScope.languageName,
          poNumber: currentQuotes.poNumber || null,
          inEdit: currentQuotes.inEdit,
          quotes: [currentQuotes],
          quoteId: currentQuotes.quoteId,
          vendorName: this.getVendorNameById(currentQuotes.vendorId),
          status: currentQuotes.status === 'APPROVED'
        })
      }
      i++;
    }
    return parsedScopes;
  };

}

export default AddEditPO;
